const ComponentIds = {
  BottomSheet: 'BottomSheet',
  BottomSheetHeader: 'BottomSheetHeader',
  BottomSheetFooter: 'BottomSheetFooter',
  BottomSheetBody: 'BottomSheetBody',
  BottomSheetGrabHandle: 'BottomSheetGrabHandle',
};

export { ComponentIds };
